let S_App = {
  STORAGE_KEY_PREFIX : 'courses',
  isLogDebug: process.env.REACT_APP_ENV === 'development'
};
export default S_App;